import React, { useRef } from 'react';
var VeltAutocompleteChipTooltipName = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-autocomplete-chip-tooltip-name", { ref: ref }, children));
};
export default VeltAutocompleteChipTooltipName;
